export const UPDATE_COMPANY_DATA = 'company/UPDATE_COMPANY_DATA'
